{
  "aa": { "label": "Afar", "flagCode": "ET" },
  "ab": { "label": "Abkhazian", "flagCode": "GE" },
  "af": { "label": "Afrikaans", "flagCode": "ZA" },
  "ak": { "label": "Akan", "flagCode": "GH" },
  "am": { "label": "Amharic", "flagCode": "ET" },
  "an": { "label": "Aragonese", "flagCode": "ES" },
  "ar": { "label": "العربية", "flagCode": "SA" },
  "as": { "label": "Assamese", "flagCode": "IN" },
  "av": { "label": "Avaric", "flagCode": "RU" },
  "ay": { "label": "Aymara", "flagCode": "BO" },
  "az": { "label": "Azerbaijani", "flagCode": "AZ" },
  "ba": { "label": "Bashkir", "flagCode": "RU" },
  "be": { "label": "Belarusian", "flagCode": "BY" },
  "bg": { "label": "Bulgarian", "flagCode": "BG" },
  "bh": { "label": "Bhojpuri", "flagCode": "IN" },
  "bi": { "label": "Bislama", "flagCode": "VU" },
  "bm": { "label": "Bambara", "flagCode": "ML" },
  "bn": { "label": "Bangla", "flagCode": "BD" },
  "bo": { "label": "Tibetan", "flagCode": "CN" },
  "br": { "label": "Breton", "flagCode": "FR" },
  "bs": { "label": "Bosnian", "flagCode": "BA" },
  "ca": { "label": "Catalan", "flagCode": "ES" },
  "ce": { "label": "Chechen", "flagCode": "RU" },
  "ch": { "label": "Chamorro", "flagCode": "GU" },
  "co": { "label": "Corsican", "flagCode": "FR" },
  "cr": { "label": "Cree", "flagCode": "CA" },
  "cs": { "label": "Czech", "flagCode": "CZ" },
  "cu": { "label": "Church Slavic", "flagCode": "RU" },
  "cv": { "label": "Chuvash", "flagCode": "CV" },
  "cy": { "label": "Welsh", "flagCode": "GB" },
  "da": { "label": "Danish", "flagCode": "DK" },
  "de": { "label": "Deutsch", "flagCode": "DE" },
  "dv": { "label": "Divehi", "flagCode": "MV" },
  "dz": { "label": "Dzongkha", "flagCode": "BT" },
  "ee": { "label": "Ewe", "flagCode": "GH" },
  "el": { "label": "Greek", "flagCode": "GR" },
  "en": { "label": "English", "flagCode": "US" },
  "eo": { "label": "Esperanto", "flagCode": "EU" },
  "es": { "label": "Español", "flagCode": "ES" },
  "et": { "label": "Estonian", "flagCode": "EE" },
  "eu": { "label": "Basque", "flagCode": "ES" },
  "fa": { "label": "Persian", "flagCode": "IR" },
  "ff": { "label": "Fula", "flagCode": "SN" },
  "fi": { "label": "Finnish", "flagCode": "FI" },
  "fj": { "label": "Fijian", "flagCode": "FJ" },
  "fo": { "label": "Faroese", "flagCode": "FO" },
  "fr": { "label": "Français", "flagCode": "FR" },
  "fy": { "label": "Western Frisian", "flagCode": "NL" },
  "ga": { "label": "Irish", "flagCode": "IE" },
  "gd": { "label": "Scottish Gaelic", "flagCode": "GB" },
  "gl": { "label": "Galician", "flagCode": "ES" },
  "gn": { "label": "Guarani", "flagCode": "PY" },
  "gu": { "label": "Gujarati", "flagCode": "IN" },
  "gv": { "label": "Manx", "flagCode": "IM" },
  "ha": { "label": "Hausa", "flagCode": "NG" },
  "he": { "label": "Hebrew", "flagCode": "IL" },
  "hi": { "label": "Hindi", "flagCode": "IN" },
  "ho": { "label": "Hiri Motu", "flagCode": "PG" },
  "hr": { "label": "Croatian", "flagCode": "HR" },
  "ht": { "label": "Haitian Creole", "flagCode": "HT" },
  "hu": { "label": "Hungarian", "flagCode": "HU" },
  "hy": { "label": "Armenian", "flagCode": "AM" },
  "hz": { "label": "Herero", "flagCode": "NA" },
  "ia": { "label": "Interlingua", "flagCode": "EU" },
  "id": { "label": "Indonesian", "flagCode": "ID" },
  "ie": { "label": "Interlingue", "flagCode": "EU" },
  "ig": { "label": "Igbo", "flagCode": "NG" },
  "ii": { "label": "Sichuan Yi", "flagCode": "CN" },
  "ik": { "label": "Inupiaq", "flagCode": "US" },
  "io": { "label": "Ido", "flagCode": "EU" },
  "is": { "label": "Icelandic", "flagCode": "IS" },
  "it": { "label": "Italiano", "flagCode": "IT" },
  "iu": { "label": "Inuktitut", "flagCode": "CA" },
  "ja": { "label": "日本語", "flagCode": "JP" },
  "jv": { "label": "Javanese", "flagCode": "ID" },
  "ka": { "label": "Georgian", "flagCode": "GE" },
  "kg": { "label": "Kongo", "flagCode": "CD" },
  "ki": { "label": "Kikuyu", "flagCode": "KE" },
  "kj": { "label": "Kuanyama", "flagCode": "NA" },
  "kk": { "label": "Kazakh", "flagCode": "KZ" },
  "kl": { "label": "Kalaallisut", "flagCode": "GL" },
  "km": { "label": "Khmer", "flagCode": "KH" },
  "kn": { "label": "Kannada", "flagCode": "IN" },
  "ko": { "label": "한국어", "flagCode": "KR" },
  "kr": { "label": "Kanuri", "flagCode": "NG" },
  "ks": { "label": "Kashmiri", "flagCode": "IN" },
  "ku": { "label": "Kurdish", "flagCode": "TR" },
  "kv": { "label": "Komi", "flagCode": "RU" },
  "kw": { "label": "Cornish", "flagCode": "GB" },
  "ky": { "label": "Kyrgyz", "flagCode": "KG" },
  "la": { "label": "Latin", "flagCode": "VA" },
  "lb": { "label": "Luxembourgish", "flagCode": "LU" },
  "lg": { "label": "Ganda", "flagCode": "UG" },
  "li": { "label": "Limburgish", "flagCode": "NL" },
  "ln": { "label": "Lingala", "flagCode": "CD" },
  "lo": { "label": "Lao", "flagCode": "LA" },
  "lt": { "label": "Lithuanian", "flagCode": "LT" },
  "lu": { "label": "Luba-Katanga", "flagCode": "CD" },
  "lv": { "label": "Latvian", "flagCode": "LV" },
  "mg": { "label": "Malagasy", "flagCode": "MG" },
  "mh": { "label": "Marshallese", "flagCode": "MH" },
  "mi": { "label": "Māori", "flagCode": "NZ" },
  "mk": { "label": "Macedonian", "flagCode": "MK" },
  "ml": { "label": "Malayalam", "flagCode": "IN" },
  "mn": { "label": "Mongolian", "flagCode": "MN" },
  "mr": { "label": "Marathi", "flagCode": "IN" },
  "ms": { "label": "Malay", "flagCode": "MY" },
  "mt": { "label": "Maltese", "flagCode": "MT" },
  "my": { "label": "Burmese", "flagCode": "MM" },
  "na": { "label": "Nauru", "flagCode": "NR" },
  "nb": { "label": "Norwegian Bokmål", "flagCode": "NO" },
  "nd": { "label": "North Ndebele", "flagCode": "ZW" },
  "ne": { "label": "Nepali", "flagCode": "NP" },
  "ng": { "label": "Ndonga", "flagCode": "NA" },
  "nl": { "label": "Nederlands", "flagCode": "NL" },
  "nn": { "label": "Norwegian Nynorsk", "flagCode": "NO" },
  "no": { "label": "Norwegian", "flagCode": "NO" },
  "nr": { "label": "South Ndebele", "flagCode": "ZA" },
  "nv": { "label": "Navajo", "flagCode": "US" },
  "ny": { "label": "Nyanja", "flagCode": "MW" },
  "oc": { "label": "Occitan", "flagCode": "FR" },
  "oj": { "label": "Ojibwa", "flagCode": "CA" },
  "om": { "label": "Oromo", "flagCode": "ET" },
  "or": { "label": "Odia", "flagCode": "IN" },
  "os": { "label": "Ossetic", "flagCode": "RU" },
  "pa": { "label": "Punjabi", "flagCode": "IN" },
  "pi": { "label": "Pali", "flagCode": "IN" },
  "pl": { "label": "Polish", "flagCode": "PL" },
  "ps": { "label": "Pashto", "flagCode": "AF" },
  "pt": { "label": "Português", "flagCode": "BR" },
  "qu": { "label": "Quechua", "flagCode": "PE" },
  "rm": { "label": "Romansh", "flagCode": "CH" },
  "rn": { "label": "Rundi", "flagCode": "BI" },
  "ro": { "label": "Romanian", "flagCode": "RO" },
  "ru": { "label": "Русский", "flagCode": "RU" },
  "rw": { "label": "Kinyarwanda", "flagCode": "RW" },
  "sa": { "label": "Sanskrit", "flagCode": "IN" },
  "sc": { "label": "Sardinian", "flagCode": "IT" },
  "sd": { "label": "Sindhi", "flagCode": "PK" },
  "se": { "label": "Northern Sami", "flagCode": "NO" },
  "sg": { "label": "Sango", "flagCode": "CF" },
  "si": { "label": "Sinhala", "flagCode": "LK" },
  "sk": { "label": "Slovak", "flagCode": "SK" },
  "sl": { "label": "Slovenian", "flagCode": "SI" },
  "sm": { "label": "Samoan", "flagCode": "WS" },
  "sn": { "label": "Shona", "flagCode": "ZW" },
  "so": { "label": "Somali", "flagCode": "SO" },
  "sq": { "label": "Albanian", "flagCode": "AL" },
  "sr": { "label": "Serbian", "flagCode": "RS" },
  "ss": { "label": "Swati", "flagCode": "SZ" },
  "st": { "label": "Southern Sotho", "flagCode": "LS" },
  "su": { "label": "Sundanese", "flagCode": "ID" },
  "sv": { "label": "Swedish", "flagCode": "SE" },
  "sw": { "label": "Swahili", "flagCode": "TZ" },
  "ta": { "label": "Tamil", "flagCode": "IN" },
  "te": { "label": "Telugu", "flagCode": "IN" },
  "tg": { "label": "Tajik", "flagCode": "TJ" },
  "th": { "label": "Thai", "flagCode": "TH" },
  "ti": { "label": "Tigrinya", "flagCode": "ER" },
  "tk": { "label": "Turkmen", "flagCode": "TM" },
  "tl": { "label": "Filipino", "flagCode": "PH" },
  "tn": { "label": "Tswana", "flagCode": "BW" },
  "to": { "label": "Tongan", "flagCode": "TO" },
  "tr": { "label": "Turkish", "flagCode": "TR" },
  "ts": { "label": "Tsonga", "flagCode": "ZA" },
  "tt": { "label": "Tatar", "flagCode": "RU" },
  "tw": { "label": "Akan", "flagCode": "GH" },
  "ty": { "label": "Tahitian", "flagCode": "PF" },
  "ug": { "label": "Uyghur", "flagCode": "CN" },
  "uk": { "label": "Ukrainian", "flagCode": "UA" },
  "ur": { "label": "Urdu", "flagCode": "PK" },
  "uz": { "label": "Uzbek", "flagCode": "UZ" },
  "ve": { "label": "Venda", "flagCode": "ZA" },
  "vi": { "label": "Vietnamese", "flagCode": "VN" },
  "vo": { "label": "Volapük", "flagCode": "EU" },
  "wa": { "label": "Walloon", "flagCode": "BE" },
  "wo": { "label": "Wolof", "flagCode": "SN" },
  "xh": { "label": "Xhosa", "flagCode": "ZA" },
  "yi": { "label": "Yiddish", "flagCode": "IL" },
  "yo": { "label": "Yoruba", "flagCode": "NG" },
  "za": { "label": "Zhuang", "flagCode": "CN" },
  "zh": { "label": "中文", "flagCode": "CN" },
  "zu": { "label": "Zulu", "flagCode": "ZA" }
}
